// You can write more code here

/* START OF COMPILED CODE */

import LaneEntityImage from './LaneEntityImage';
/* START-USER-IMPORTS */
import { BodyTypes } from '../../LevelManager';
/* END-USER-IMPORTS */

export default class Ramp extends LaneEntityImage {
  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 238, y ?? 132, texture || 'game', frame ?? 'ramp-v1.png');

    this.setOrigin(0.5, 0.5);

    // this (prefab fields)
    this.spawnOffsetY = 95;

    /* START-USER-CTR-CODE */
    this.rampEntranceWidth = 40;
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */
  protected rampEntranceWidth: number;

  public init() {
    this.setDepth(this.getRampEntry() - this.rampEntranceWidth * 0.5);

    let x = this.x;
    let y = this.y;

    let rect: MatterJS.BodyType = this.scene.matter.bodies.rectangle(this.x, this.y, this.displayWidth, this.rampEntranceWidth, {
      label: BodyTypes.Ramp,
      isSensor: true,
      isStatic: true
    });
    rect.position.y -= this.spawnOffsetY;

    this.setExistingBody(rect);

    this.scene.matter.body.setPosition(this.body as MatterJS.BodyType, this.scene.matter.vector.create(x, y));
    this.scene.matter.setVelocity(this.body as MatterJS.BodyType, 0, 0);

    super.init();
  }

  public isRing(): boolean {
    return false;
  }

  public getRampEntry(): number {
    return this.y + this.spawnOffsetY + this.rampEntranceWidth * 0.5;
  }

  public getBlockZone(): Phaser.Geom.Rectangle {
    return new Phaser.Geom.Rectangle(this.x - this.displayOriginX, this.y + this.spawnOffsetY, this.width, this.rampEntranceWidth);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

export const RampSkins = {
  Normal: 'ramp-v1.png',
  Scrap: 'ramp-scrapyard.png',
  Dock: 'ramp-docks.png',
  Ice: 'ramp-ice.png',
} as const;
export type RampSkinsKeys = keyof typeof RampSkins;
export type RampSkinsValues = typeof RampSkins[RampSkinsKeys];
